import React, { useEffect, useRef } from "react";
import styles from "./comp_css/chapter_57.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter61.json";
import Head from "next/head";
export default function Chapter_61() {

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>
      <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Julian, Iamblichus, polytheism, Neoplatonism, theurgy, Helios, Rome, festivals, rituals, philosophy, harmony, cosmic order, tradition, restoration, spirituality."
        ></meta>
        <meta
          property="og:title"
          content="Daemons, Nature, and the Soul’s Journey Through Sacred Worlds"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="From Vietnamese Goddess worship to Iamblichan Platonism, diverse traditions see nature as alive with spirits. These beings—whether rivers, mountains, or daemones—guide the soul through matter toward divine origins. Ancient Greek, Egyptian, and Mesopotamian thought share this vision, honoring intermediaries who bridge human and cosmic realms, preserving harmony between the sacred world and humanity."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=61"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=61"
        ></meta>
        <meta
          name="twitter:title"
          content="Daemons, Nature, and the Soul’s Journey Through Sacred Worlds"
        ></meta>
        <meta
          name="twitter:description"
          content="Across cultures, nature teems with spirits guiding life’s journey. Vietnamese Goddess worship, Greek daemones, and Egyptian ka and ba all express humanity’s bond with divine intermediaries. These beings help the soul navigate matter, remember its origins, and return to the cosmic source, sustaining harmony between people, nature, and the sacred order of the universe."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=61" />
      </Head>
      <Common_html BlockData={BlockData} />
    </>
  );
}
